import { swapKeyValue } from '../lib/utils';

export default (models, Renderer) => {
  const Model = {};

  Model.s = models;
  Model.mapToRenderers = swapKeyValue(Renderer.mapToModel, true);

  Model.test = parsing => Promise.resolve(parsing).then((parsed) => {
    const { modelName } = parsed;
    if (!(models[modelName].test(parsed))) return Promise.reject(Error('[[error:invalid-parsed-data]]'));
    return parsed;
    // TODO test postData model (return value)
  });

  return Model;
};
